import { axiosRequest } from "../../service";
import {
  REACT_APP_KSHEMA_POC2,
  REACT_APP_VAM_CONTEXT_INGESTION,
  REACT_APP_VAM_ENDPOINT,
  WRAPPER_SERVICE,
} from "../../urls";

export const fetchClaimSearchfields = async (setLoading) => {
  try {
    setLoading(true)
    const response = await axiosRequest().get(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}/getClaimSubStatus`
    );
    return response;
  } catch (error) {
    console.error("Error fetching Claim Search fields:", error);
    setLoading(false)
    return [];
  }
};

export const fetchPolicyStatusOptions = async (setLoading) => {
  try {
    setLoading(true)
    const response = await axiosRequest().get(
      `${REACT_APP_KSHEMA_POC2}/government-status`
    );
    return response;
  } catch (error) {
    console.error("Error fetching Claim Search fields:", error);
    setLoading(false)
    return [];
  }
};

export const fetchClaimDetails = async (claimno, setLoading) => {
  try {
    setLoading(true)
    const response = await axiosRequest().get(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}/claim-record/${claimno}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching Claim Search fields:", error);
    setLoading(false)
    return [];
  }
};

export const fetchPolicySearch = async (payload, setLoading) => {
  try {
    setLoading(true)
    const response = await axiosRequest().post(
      `${WRAPPER_SERVICE}/search`,
      payload
    );
    return response;
  } catch (error) {
    console.error("Error fetching Claim Search fields:", error);
    setLoading(false)
    return [];
  }
};

export const fetchBasicSearch = async (payload) => {
  try {
    const response = await axiosRequest().post(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}/details`,
      payload
    );
    return response;
  } catch (error) {
    console.error("Error fetching Claim Search fields:", error);
    return [];
  }
};
